import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'types';
import { initialState } from '.';

const selectSlice = (state: RootState) => state.landing || initialState;
export const selectLanding = createSelector([selectSlice], state => state);
